const flights = {
  flight: "เที่ยวบิน", // translated
  flights: "เที่ยวบิน", // translated
  originDepartureDate: "การออกเดินทาง", // translated
  destinationDepartureDate: "กลับ", // translated
  outbound: "ขาออก", // translated
  inbound: "ขาเข้า", // translated
  travelTime: "เวลาเที่ยว", // translated
  selected: "เลือกแล้ว", // translated
  select: "เลือก", // translated
  airline: "สายการบิน", // translated
  directFlight: "เที่ยวบินตรง", // translated
  baggage: "สัมภาระ", // translated
  stops: "หยุด", // translated
  nonStop: "ไม่หยุด", // translated
  oneStopMax: "สูงสุดหนึ่งจุด", // translated
  twoStopsMax: "สูงสุดสองจุด", // translated
  anyStops: "ไม่ว่าจะจอดแบบไหนก็ตาม", // translated
  smallBaggage: "สัมภาระขนาดเล็ก", // translated
  bigBaggage: "สัมภาระขนาดใหญ่", // translated
  smallAndBigBaggage: "สัมภาระขนาดเล็กและใหญ่", // translated
  outboundStops: "ขาออกหยุด", // translated
  inboundStops: "ขาเข้าหยุด", // translated
  selectAirline: "เลือกสายการบิน", // translated
  baggageOption: "ตัวเลือกสัมภาระ", // translated
  outboundDepartureAfter: "ขาออกออกเดินทางหลังจากนั้น", // translated
  outboundArrivalAfter: "ขาออกมาถึงหลังจากนั้น", // translated
  inboundDepartureAfter: "ขาเข้าออกเดินทางหลังจากนั้น", // translated
  inboundArrivalTimeAfter: "ขาเข้ามาถึงทีหลัง", // translated
  flightClass: "ชั้นบิน", // translated
  outboundDepAfter: "ออกเดินทางหลังจากนั้น", // translated
  outboundArrivalAfrer: "ออกมาถึงหลังจากนั้น", // translated
  inboundDepAfter: "ในการออกเดินทางหลังจากนั้น", // translated
  inboundArrivalAfter: "ในการมาถึงหลังจากนั้น", // translated
  airlines: "สายการบิน", // translated
  lessThan: "น้อยกว่า", // translated
  layover: "แวะพัก", // translated
  duration: "ระยะเวลา", // translated
  economy: "ชั้นประหยัด", // translated
  business: "ชั้นธุรกิจ", // translated
  with: "กับ", // translated
  without: "ปราศจาก", // translated
  twoOrMore: "สองหรือมากกว่านั้น", // translated
  departure: "การออกเดินทาง", // translated
  return: "กลับ", // translated
  submit: "ส่ง", // translated
  priceLessThan: "ราคาต่ำกว่า", // translated
  durationLessThan: "ระยะเวลาน้อยกว่า", // translated
  layoverLessThan: "หยุดพักระหว่างทางน้อยกว่า", // translated
  noLayover: "ไม่มีการหยุดพักระหว่างทาง", // translated
  durationLowestFirst: "ระยะเวลา (ต่ำสุดก่อน)", // translated
  durationHighestFirst: "ระยะเวลา (สูงสุดก่อน)", // translated
  idType: "ประเภทบัตรประจำตัว", // translated
  idPassportCode: "บัตรประจำตัวประชาชน/รหัสหนังสือเดินทาง", // translated
  expirationDate: "วันหมดอายุ", // translated
  frequentFlyerNumber: "หมายเลขสะสมไมล์", // translated
  frequentFlyerAirline: "สายการบิน Frequent Flyer", // translated
  dateOfBirth: "วันเกิด", // translated
  infant: "เด็กทารก", // translated
  phone: "โทรศัพท์", // translated
  title: "ชื่อ", // translated
  noLuggageIncluded: "ไม่รวมกระเป๋าเดินทาง", // translated
  includesLuggage: "รวมถึงกระเป๋าเดินทาง", // translated
  outboundFlight: "เที่ยวบินขาออก", // translated
  inboundFlight: "เที่ยวบินขาเข้า", // translated
  flightNumber: "เที่ยวบินหมายเลข", // translated
  flightNumbers: "หมายเลขเที่ยวบิน", // translated
  cabinClassType: "ประเภทห้องโดยสาร", // translated
  aircraftType: "ประเภทเครื่องบิน", // translated
  airlineName: "ชื่อสายการบิน", // translated
  no: "เลขที่", // translated
  yes: "ใช่", // translated
  anyFlights: "เที่ยวบินใดก็ได้", // translated
  oneStop: "หนึ่งหยุด", // translated
  direct: "โดยตรง", // translated
  directFlights: "เที่ยวบินตรง", // translated
  all: "ทั้งหมด", // translated
  first: "ชั้นหนึ่ง", // translated
  premiumEconomy: "ชั้นประหยัดพรีเมียม", // translated
  withBaggageOnly: "พร้อมสัมภาระเท่านั้น", // translated
  oneWay: "เที่ยวเดียว", // translated
  roundTrip: "ไป - กลับ", // translated
  withBaggage: "พร้อมสัมภาระ", // translated
  noBaggage: "ไม่มีสัมภาระ", // translated
  requiredFields: "ช่องที่ต้องเติม", // translated
  nonRequiredFields: "ฟิลด์ที่ไม่จำเป็น", // translated
  cabinClass: "คลาสห้องโดยสาร", // translated
  brandName: "ชื่อแบรนด์", // translated
  performNewSearch: "ทำการค้นหาใหม่", // translated
  outboundDeparture: "ขาออก", // translated
  inboundDeparture: "ขาออกขาเข้า", // translated
  created: "สร้าง", // translated
  freeCancellationAvailable: "สามารถยกเลิกได้ฟรี", // translated
  freeCancellationDeadline: "กำหนดเวลาการยกเลิกฟรี", // translated
  externalReference: "การอ้างอิงภายนอก", // translated
  outboundflightNumber: "หมายเลขเที่ยวบินขาออก", // translated
  inboundflightNumber: "หมายเลขเที่ยวบินขาเข้า", // translated
  arrival: "การมาถึง", // translated
};

export default flights;
